export default __webpack_public_path__ + "static/kgw-brown-65462180982cc856bc969a27accece48.png";